import styled from '@emotion/styled';
import { ButtonLinkWithIcon, Divider, Modal } from '@blueprint/ui';
import { css } from '@emotion/react';

type AlertPanelWrapperProps = {
    color?:
        | 'white'
        | 'graphic-background-accent'
        | 'graphic-background-accent-light';
};

export const StyledModal = styled(Modal)(
    ({ theme }) => css`
        border-radius: ${theme.borderRadius['100']};
    `
);

// TODO: refactor to card?
export const AlertPanelWrapper = styled('div')<AlertPanelWrapperProps>(
    ({ theme, color = 'white' }) => css`
        background-color: ${theme.colors[color]};
        padding: ${theme.spacing['32px']} ${theme.spacing['24px']};
        width: 100%;
        box-shadow: ${theme.boxShadow['200']};
    `
);

export const AlertPanelButtonLink = styled(ButtonLinkWithIcon)(
    ({ theme }) => css`
        margin-top: ${theme.spacing['16px']};

        &:first-of-type {
            margin-top: 0;
        }

        ${theme.mq.large} {
            display: flex;
        }
    `
);

export const LeftAlignButtonWithIcon = styled(AlertPanelButtonLink)(
    (props) => `
    justify-content: left;
    padding: ${props.theme.spacing['8px']} 0;
`
);

export const PaddedDivider = styled(Divider)(
    (props) => `
    margin: ${props.theme.spacing['32px']} auto;
`
);
